import {toastr} from 'react-redux-toastr';
import {
  initialize
} from 'redux-form';
import {
  navigateTo,
  postJsonAsync,
  putJsonAsync
} from 'shared/actions';
import {loadTournament} from '../actions';
 
export const handleSave = data => dispatch => new Promise((resolve) => {
  const promise = data.id
    ? putJsonAsync(`setup/tournament/${data.id}`, data)
    : postJsonAsync('setup/tournament', data);

  dispatch(promise)
  .then(() => {
    toastr.success('Saved!', 'Tournament saved Successfully.');
    resolve();
    dispatch(initialize('tournamentCom', data));
    dispatch(loadTournament(data.id));
  })
  .catch(() => resolve());
});
  
export const handleCancel = () => dispatch =>
  dispatch(navigateTo('tournament'));

export const setupTournamentComForm = () => (dispatch, getState) => {
  const data = getState().tournament.base.tournamentInfo;
  
  dispatch(initialize('tournamentCom', {
    ...data 
  }));
};



// WEBPACK FOOTER //
// ./src/features/tournament/communications/actions.js